import { ChakraProvider, extendTheme } from "@chakra-ui/react";
import { Reports43101Navbar } from "./components/Reports43101Navbar";
import { Reports43101Body } from "./components/Reports43101Body";

// Custom theme with mining-inspired color palette
const theme = extendTheme({
  colors: {
    slate: {
      50: "#f8fafc",
      100: "#f1f5f9",
      200: "#e2e8f0",
      300: "#cbd5e1",
      400: "#94a3b8",
      500: "#64748b",
      600: "#475569",
      700: "#334155",
      800: "#1e293b",
      900: "#0f172a",
    },
    amber: {
      50: "#fffbeb",
      100: "#fef3c7",
      200: "#fde68a",
      300: "#fcd34d",
      400: "#fbbf24",
      500: "#f59e0b",
      600: "#d97706",
      700: "#b45309",
      800: "#92400e",
      900: "#78350f",
    },
  },
  fonts: {
    heading: "'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif",
    body: "'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif",
  },
  styles: {
    global: {
      body: {
        bg: "slate.100",
        color: "slate.800",
      },
    },
  },
  components: {
    Button: {
      defaultProps: {
        colorScheme: "amber",
      },
    },
    Input: {
      defaultProps: {
        focusBorderColor: "amber.400",
      },
    },
  },
});

const Main = () => {
  return (
    <div style={{ minHeight: "100vh", background: "#f1f5f9" }}>
      <Reports43101Navbar />
      <Reports43101Body />
    </div>
  );
};

export function Reports43101App() {
  return (
    <ChakraProvider theme={theme}>
      <Main />
    </ChakraProvider>
  );
}

